const houseParts = require('../house-parts');
const channels = require('../channels');
const types = require('../types');
const themeGroups = require('../theme-groups');
const themes = require('../themes');
const elementGroups = require('../element-groups');
const byoThemeElements = require('../byo-theme-elements');

// const icicles = require('./icicles');
const fence = require('./fence');
const letterboxTrees = require('./letterbox-trees');
const peppermintTree = require('./peppermint-tree');
const miniTrees = require('./mini-trees');
const motifs = require('./motifs');
const roof = require('./roof');
const ropes = require('./rope-lights');
const tree = require('./tree');

module.exports = {
  // ...icicles,
  ...fence,
  ...letterboxTrees,
  ...peppermintTree,
  // ...miniTrees,
  ...motifs,
  ...roof,
  ...ropes,
  ...tree,

  BLOSSOMS_1: {
    id: 'BLOSSOMS_1',
    name: 'Blossom Tree 1',
    animation: 'OFF',
    type: types.BlossomTrees,
    housePart: houseParts.FENCE.id,
    availableInThemes: [...themeGroups.COOL_WHITE, themes.MOTIFS],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  BLOSSOMS_2: {
    id: 'BLOSSOMS_2',
    name: 'Blossom Tree 2',
    animation: 'OFF',
    type: types.BlossomTrees,
    housePart: houseParts.FENCE.id,
    availableInThemes: [...themeGroups.COOL_WHITE, themes.MOTIFS],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  BLOSSOMS_3: {
    id: 'BLOSSOMS_3',
    name: 'Blossom Tree 3',
    animation: 'OFF',
    type: types.BlossomTrees,
    housePart: houseParts.FENCE.id,
    availableInThemes: [...themeGroups.COOL_WHITE, themes.MOTIFS],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  BLOSSOMS_4: {
    id: 'BLOSSOMS_4',
    name: 'Blossom Tree 4',
    animation: 'OFF',
    type: types.BlossomTrees,
    housePart: houseParts.FENCE.id,
    availableInThemes: [...themeGroups.COOL_WHITE, themes.MOTIFS],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  REINDEER_JANE_CW: {
    id: 'REINDEER_JANE_CW',
    name: 'Reindeer - Jane (Cool)',
    animation: 'OFF',
    type: types.CoolWhite,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.JANE_REINDEER.id,
    availableInThemes: [...themeGroups.COOL_WHITE, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },
  REINDEER_JANE_WW: {
    id: 'REINDEER_JANE_WW',
    name: 'Reindeer - Jane (Warm)',
    animation: 'OFF',
    type: types.WarmWhite,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.JANE_REINDEER.id,
    availableInThemes: [...themeGroups.WARM_WHITE, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },
  REINDEER_JANE_MULTI: {
    id: 'REINDEER_JANE_MULTI',
    name: 'Reindeer - Jane (Multi)',
    animation: 'OFF',
    type: types.Multi,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.JANE_REINDEER.id,
    availableInThemes: [...themeGroups.MULTI, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  REINDEER_JO_CW: {
    id: 'REINDEER_JO_CW',
    name: 'Reindeer - Jo (White)',
    animation: 'OFF',
    type: types.CoolWhite,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.JO_REINDEER.id,
    availableInThemes: [...themeGroups.COOL_WHITE, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },
  REINDEER_JO_WW: {
    id: 'REINDEER_JO_WW',
    name: 'Reindeer - Jo (Warm)',
    animation: 'OFF',
    type: types.WarmWhite,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.JO_REINDEER.id,
    availableInThemes: [...themeGroups.WARM_WHITE, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },
  REINDEER_JO_MULTI: {
    id: 'REINDEER_JO_MULTI',
    name: 'Reindeer - Jo Doe (Multi)',
    animation: 'OFF',
    type: types.Multi,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.JO_REINDEER.id,
    availableInThemes: [...themeGroups.MULTI, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  REINDEER_BUCKY_CW: {
    id: 'REINDEER_BUCKY_CW',
    name: 'Reindeer - Bucky (White)',
    animation: 'OFF',
    type: types.CoolWhite,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.BUCKY_REINDEER.id,
    availableInThemes: [...themeGroups.COOL_WHITE, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },
  REINDEER_BUCKY_WW: {
    id: 'REINDEER_BUCKY_WW',
    name: 'Reindeer - Bucky (Warm)',
    animation: 'OFF',
    type: types.WarmWhite,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.BUCKY_REINDEER.id,
    availableInThemes: [...themeGroups.WARM_WHITE, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },
  REINDEER_BUCKY_MULTI: {
    id: 'REINDEER_BUCKY_MULTI',
    name: 'Reindeer - Bucky (Multi)',
    animation: 'OFF',
    type: types.Multi,
    housePart: houseParts.REINDEER.id,
    byoThemeElementId: byoThemeElements.BUCKY_REINDEER.id,
    availableInThemes: [...themeGroups.MULTI, themes.MOTIFS],
    groups: [elementGroups.GARDEN],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  ELF_TREE_1: {
    id: 'ELF_TREE_1',
    name: 'Elf Tree 1',
    animation: 'off',
    type: types.RedGreen,
    housePart: houseParts.GARDEN.id,
    byoThemeElementId: byoThemeElements.ELF_TREE.id,
    availableInThemes: [...themeGroups.MULTI],
    groups: [elementGroups.GARDEN, elementGroups.TREES],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  },

  ELF_TREE_2: {
    id: 'ELF_TREE_2',
    name: 'Elf Tree 2',
    animation: 'off',
    type: types.RedGreen,
    housePart: houseParts.GARDEN.id,
    byoThemeElementId: byoThemeElements.ELF_TREE.id,
    availableInThemes: [...themeGroups.MULTI],
    groups: [elementGroups.GARDEN, elementGroups.TREES],
    brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  }

  // LETTERBOX: {
  //   id: 'LETTERBOX',
  //   name: 'Letterbox',
  //   animation: 'off',
  //   type: types.Multi,
  //   housePart: houseParts.GARDEN.id,
  //   byoThemeElementId: byoThemeElements.LETTERBOX.id,
  //   availableInThemes: [...themeGroups.MULTI],
  //   groups: [elementGroups.GARDEN, elementGroups.TREES],
  //   brightness: { [channels.CONST__CH_1]: 0, [channels.CONST__CH_2]: 0 }
  // }
};
